/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import TranscriptionSVG from "assets/transcription-icon.svg";
import { skaleBackgroundBlue } from "config/UpduoColors";

export default function TranscriptionIcon({ isSelected = false }) {
  return (
    <View
      style={{
        alignItems: "center",
        justifyContent: "center",
        width: 38,
        height: 38,
        backgroundColor: skaleBackgroundBlue,
        borderRadius: 7,
        marginVertical: 3,
        borderColor: isSelected ? "#367CF6" : undefined,
        borderWidth: isSelected ? 1 : 0,
      }}
    >
      <img
        src={TranscriptionSVG}
        style={{ width: 28, cursor: "pointer" }}
        alt={"transcription"}
      />
    </View>
  );
}
